export default "__VITE_ASSET__DmL6Jy4s__"